import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NetworkWifi2BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"network_wifi_2_bar"}/>
}
